<template>
    <div class="vx-date-range-input flex flex-nowrap w-full items-center justify-center">
        <vx-calendar-input v-model="start" />
        <vx-basic-icon class="mx-4" style="padding-bottom: 18px" icon="ArrowRightIcon" size="6" />
        <vx-calendar-input v-model="end" />
    </div>
</template>

<script>
export default {
    name: 'vx-date-range-input',
    props: {
        value: {
            type: Object,
            default: function () {
                return {
                    start: null,
                    end: null
                }
            }
        }
    },
    data() {
        return {}
    },
    computed: {
        start: {
            get() {
                return this.value && this.value.start
            },
            set(v) {
                var newV = {
                    start: v,
                    end: this.end
                }
                this.$emit('input', newV)
            }
        },
        end: {
            get() {
                return this.value && this.value.end
            },
            set(v) {
                var newV = {
                    start: this.start,
                    end: v
                }
                this.$emit('input', newV)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
